module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to my wonderful wife, supporter and reader, Michele; my writer son, Sean Kanan, who provided me with the idea for this book; and my daughter, Robyn Bernstein, for being my daughter and a great writer as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is my fourth book with The History Press, and my acquisitions editor, Banks Smither, has again provided his invaluable support. I also appreciate the hard work and support of my editor Ashley Hill.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 69
// module chunks = 0